import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "ant-pro-header-account-name anticon",
  style: {"color":"#ffffff"}
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_lock_outlined = _resolveComponent("lock-outlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_setting_outlined = _resolveComponent("setting-outlined")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_logout_outlined = _resolveComponent("logout-outlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currentUser && _ctx.currentUser.nickname)
      ? (_openBlock(), _createBlock(_component_a_dropdown, {
          key: 0,
          class: "ant-pro-dropdown ant-pro-dropdown-action",
          placement: "bottomRight",
          overlayClassName: "pro-components-header-dropdown-index-container"
        }, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, {
              class: "ant-pro-dropdown-menu",
              "selected-keys": []
            }, {
              default: _withCtx(() => [
                (_ctx.menu)
                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: "changePw",
                      onClick: _ctx.changePw
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_lock_outlined)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 修改密码 ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.menu)
                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: "settings",
                      onClick: _ctx.handleToSettings
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_setting_outlined)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 个人设置 ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.menu)
                  ? (_openBlock(), _createBlock(_component_a_menu_divider, { key: 2 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_menu_item, {
                  key: "logout",
                  onClick: _ctx.handleLogout
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_logout_outlined)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" 退出登录 ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              (_ctx.currentUser.avatar)
                ? (_openBlock(), _createBlock(_component_a_avatar, {
                    key: 0,
                    size: "small",
                    src: _ctx.currentUser.avatar,
                    class: "ant-pro-header-account-avatar"
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock(_component_a_avatar, {
                    key: 1,
                    size: "small",
                    class: "ant-pro-header-account-avatar"
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_UserOutlined)
                    ]),
                    _: 1
                  })),
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.currentUser.nickname), 1)
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_component_a_spin, {
            size: "small",
            style: { marginLeft: 8, marginRight: 8 }
          })
        ])),
    _createVNode(_component_a_modal, {
      visible: _ctx.changePwVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.changePwVisible) = $event)),
      title: "修改密码",
      onOk: _ctx.handleChangePwOk,
      onCancle: _ctx.handleChangePwCancel,
      footer: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, _mergeProps({
          ref: "formRef",
          name: "custom-validation",
          model: _ctx.formState,
          rules: _ctx.rules
        }, _ctx.layout, {
          onFinish: _ctx.handleFinish,
          onValidate: _ctx.handleValidate,
          onFinishFailed: _ctx.handleFinishFailed
        }), {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "旧密码",
              name: "currentPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.currentPassword,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.currentPassword) = $event)),
                  type: "password",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              "has-feedback": "",
              label: "新密码",
              name: "newPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.newPassword,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.newPassword) = $event)),
                  type: "password",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              "has-feedback": "",
              label: "再次输入新密码",
              name: "checkPass"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.checkPass,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.checkPass) = $event)),
                  type: "password",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { "wrapper-col": { span: 12, offset: 6 } }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  onClick: _ctx.handleChangePwCancel,
                  style: {"margin-left":"30px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("取消")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  onClick: _ctx.handleChangePwOk,
                  style: {"margin-left":"20px"},
                  type: "primary",
                  "html-type": "submit",
                  loading: _ctx.changePwLoading,
                  disabled: _ctx.disabledChangePw
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("确认修改")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["model", "rules", "onFinish", "onValidate", "onFinishFailed"])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "onCancle"])
  ], 64))
}